<div #outsideModal class="modal">
    <div #modalBody class="modal-content">
        <div class="modal-header"> {{modalTitle}} </div>
        <div class="modal-body">
            <form [formGroup]="formGroup" class="form-card-content" (ngSubmit)="onSubmit()" *ngIf="formGroup">
                <div class="col-container">
                    <div class="col">
                        <frg-form-input label="Titre" id="titre" type="ngSelect" [formGroup]="formGroup"
                            [control]="formGroup.get('titre')" class="patient-form-input" [selectValue]="titres"
                            [isClearableSelect]="true" isParentModal="true">
                        </frg-form-input>
                        <frg-form-input label="Sexe" id="sexe" type="ngSelect" [formGroup]="formGroup"
                            [control]="formGroup.get('sexe')" class="patient-form-input" required="true" [selectValue]="sexes"
                            [isClearableSelect]="true" isParentModal="true" [ngStyle]="{'color': 'red' }">
                        </frg-form-input>
                        <frg-form-input label="Nom de naissance" id="nomNaissance" type="text" placeholder="Ex: Dupont"
                            [formGroup]="formGroup" [control]="formGroup.get('nomNaissance')" required="true"
                            class="patient-form-input" (keyup)="doUppercaseInputValue(formGroup.get('nomNaissance'))" [ngStyle]="{'color': 'red' }">
                        </frg-form-input>
                        <frg-form-input label="Nom utilisé" id="nom" type="text" placeholder="Ex: Dupont"
                            [formGroup]="formGroup" [control]="formGroup.get('nom')" class="patient-form-input"
                            (keyup)="doUppercaseInputValue(formGroup.get('nom'))">
                        </frg-form-input>
                        <frg-form-input label="Prénom(s) de naissance" id="prenomsNaissance" type="text" placeholder="Ex: Dupont"
                            [formGroup]="formGroup" [control]="formGroup.get('prenomsNaissance')" class="patient-form-input" (keyup)="doUppercaseInputValue(formGroup.get('prenomsNaissance'))">
                        </frg-form-input>
                        <ng-container *ngIf="canDisplayPickName(); else noBirthNames">
                            <span class="field-prenom">
                                <frg-form-input label="1er prénom de naissance" id="prenom" type="text" placeholder="Ex: Jean" [disabled]="infosFromInsi"
                                    [formGroup]="formGroup" [control]="formGroup.get('prenom')" class="patient-form-input"
                                    required="true" [ngStyle]="{'color': 'red' }" (keyup)="doUppercaseInputValue(formGroup.get('prenom'))">
                                </frg-form-input>
                                <div class="add-wrapper" (click)="firstNamePropals()" title="Sélectionner un prénom">
                                    <div class="pick-name"></div>
                                </div>
                            </span>
                        </ng-container>
                        <ng-template #noBirthNames>
                            <frg-form-input label="1er prénom de naissance" id="prenom" type="text" placeholder="Ex: Jean" [disabled]="infosFromInsi"
                                [formGroup]="formGroup" [control]="formGroup.get('prenom')" class="patient-form-input"
                                required="true" [ngStyle]="{'color': 'red' }" (keyup)="doUppercaseInputValue(formGroup.get('prenom'))">
                            </frg-form-input>
                        </ng-template>
                        <frg-form-input label="Prénom utilisé" id="prenomUsage" type="text" placeholder="Ex: Jean"
                            [formGroup]="formGroup" [control]="formGroup.get('prenomUsage')" class="patient-form-input"
                            (keyup)="doUppercaseInputValue(formGroup.get('prenomUsage'))">
                        </frg-form-input>
                        <frg-form-input label="Date de naissance" id="dateNaissance" type="date"
                            placeholder="JJ/MM/AAAA" [formGroup]="formGroup" [control]="formGroup.get('dateNaissance')"
                            class="patient-form-input" required="true" [ngStyle]="{'color': 'red' }" [minDate]="minDate" [maxDate]="maxDate">
                        </frg-form-input>
                        <div class="input-container">
                            <frg-form-input label="Ville de naissance" id="villeNaissance" type="text" placeholder="Ex: Paris"
                                [formGroup]="formGroup" [control]="formGroup.get('villeNaissance')" class="patient-form-input"
                                [disabled]="formGroup.get('lieuNaissanceInconnu')?.value" (keyup)="onVilleChange($event.target.value, 'ville')">
                            </frg-form-input>
                            <ng-container *ngIf="activeSearchField === 'ville'">
                                <ng-container *ngIf="communesNaissance$ | async as communes">
                                    <ul *ngIf="communes.length > 0" class="suggestions-list">
                                        <li *ngFor="let commune of communes" (click)="selectCity(commune)">
                                            {{ commune.nom }} - {{ commune.code}}
                                        </li>
                                    </ul>
                                </ng-container>
                            </ng-container>
                        </div>

                        <div class="checkbox-group">
                            <label class="checkbox-label">
                                <input type="checkbox" [formControl]="formGroup.get('lieuNaissanceInconnu')">
                                <span>Lieu de naissance inconnu</span>
                            </label>
                            <label class="checkbox-label">
                                <input type="checkbox" [(ngModel)]="isDomTomChecked" [ngModelOptions]="{standalone: true}" (change)="onVilleChange(formGroup.get('cpNaissance').value)">
                                <span>Communes des DOM-TOM</span>
                            </label>
                        </div>

                        <div class="input-container">
                            <frg-form-input label="Code lieu de naissance" id="cpNaissance" type="text" placeholder="Ex: 75015"
                                [formGroup]="formGroup" [control]="formGroup.get('cpNaissance')" class="patient-form-input" required="true" [ngStyle]="{'color': 'red' }"
                                [disabled]="formGroup.get('lieuNaissanceInconnu')?.value" (input)="onVilleChange($event.target.value, 'code')"
                                pattern="[0-9]*" [maxlength]="5" errorMessage="Le code doit contenir uniquement des chiffres">
                            </frg-form-input>
                            <ng-container *ngIf="activeSearchField === 'code'">
                                <ng-container *ngIf="communesNaissance$ | async as communes">
                                    <ul *ngIf="communes.length > 0" class="suggestions-list">
                                        <li *ngFor="let commune of communes" (click)="selectCity(commune)">
                                            {{ commune.code }} - {{ commune.nom}}
                                        </li>
                                    </ul>
                                </ng-container>
                            </ng-container>
                        </div>
                        
                        <frg-form-input label="Pays de naissance" id="paysNaissance" type="ngSelect" [disabled]="formGroup.get('lieuNaissanceInconnu')?.value"
                            [selectValue]="paysList" [checkSelectValueLength]="true" [formGroup]="formGroup" [control]="formGroup.get('paysNaissance')"
                            (modelChanged)="onPaysChange($event)" [isClearableSelect]="true" class="patient-form-input">
                        </frg-form-input>
                        <frg-form-input label="Responsable du dossier" id="responsable" type="ngSelect"
                            [formGroup]="formGroup" [control]="formGroup.get('responsable')" class="patient-form-input"
                            [selectValue]="responsables" [isClearableSelect]="false" isParentModal="true">
                        </frg-form-input>
                        <frg-form-input label="Consentement express recueilli" id="consentement" type="checkbox"
                            [formGroup]="formGroup" [control]="formGroup.get('consentement')" class="patient-form-input"
                            [isCheckLabelAlign]="true" [isGreenLabel]="true">
                        </frg-form-input>
                        <p>Le patient accepte que son dossier soit confié aux autres professionnels de santé de la
                            structure de soins.</p>
                    </div>
                    <div class="col">
                        <frg-form-input label="Adresse" id="adresse" type="text" [formGroup]="formGroup"
                            [control]="formGroup.get('adresse')" class="patient-form-input"
                            (keyup)="sanitizeEntries(formGroup.get('adresse'))">
                        </frg-form-input>
                        <frg-form-input label="Complément d'adresse" id="compAdresse" type="text"
                            [formGroup]="formGroup" [control]="formGroup.get('compAdresse')" class="patient-form-input"
                            (keyup)="sanitizeEntries(formGroup.get('compAdresse'))">
                        </frg-form-input>
                        <div class="inline-inputs">
                            <frg-form-input label="Code postal" id="codePostal" type="text" [formGroup]="formGroup"
                                [control]="formGroup.get('codePostal')" class="patient-form-input"
                                pattern="[0-9]*" [maxlength]="5" errorMessage="Le code doit contenir uniquement des chiffres">
                            </frg-form-input>
                            <frg-form-input label="Ville" id="ville" type="text" [formGroup]="formGroup"
                                [control]="formGroup.get('ville')" class="patient-form-input"
                                (keyup)="sanitizeEntries(formGroup.get('ville'))">
                            </frg-form-input>
                        </div>
                        <frg-form-input label="Email" id="email" type="email" [formGroup]="formGroup"
                            [control]="formGroup.get('email')" class="patient-form-input"
                            errorMessage="Le mail saisi est incorrect" (keyup)="sanitizeEntries(formGroup.get('email'))">
                        </frg-form-input>
                        <frg-form-input label="Téléphone" id="telephone" type="text" [formGroup]="formGroup"
                            [control]="formGroup.get('telephone')" class="patient-form-input"
                            errorMessage="Le numéro saisi est incorrect" (keyup)="sanitizeEntries(formGroup.get('telephone'))">
                        </frg-form-input>
                        <frg-form-input label="Document d'identité" id="idDocIdentite" type="ngSelect" [selectValue]="docsIdentiteList"
                            [formGroup]="formGroup" [control]="formGroup.get('idDocIdentite')"
                            class="search-form-input align">
                        </frg-form-input>
                        <frg-form-input label="Attribut identité" id="idAttrIdentite" type="ngSelect" [selectValue]="attributsIdentiteList"
                            [formGroup]="formGroup" [control]="formGroup.get('idAttrIdentite')"
                            class="search-form-input align">
                        </frg-form-input>
                        <frg-form-input label="Note" id="note" type="textarea" [formGroup]="formGroup"
                            [control]="formGroup.get('note')" class="patient-form-input" [nbRows]="6"
                            (keyup)="sanitizeEntries(formGroup.get('note'))">
                        </frg-form-input>
                        <frg-form-input label="Forcer la validation d'Identité" id="forceIdentiteValidation" type="checkbox"
                            [formGroup]="formGroup" [control]="formGroup.get('forceIdentiteValidation')" class="patient-form-input"
                            [isCheckLabelAlign]="true">
                        </frg-form-input>
                    </div>
                </div>
                <div class="button-wrapper">
                    <div class="button-insi" *ngIf="!maskInsAndCV">
                        <div class="insi" type="button" (mousedown)="lectureInsi()" *ngIf="insRight && insRight.acces > 0">INSi</div>
                        <div class="carte-vitale" type="button" (mousedown)="lectureVitale()"></div>
                    </div>
                    <div class="buttons">
                        <frg-button (activated)="closeAddEditModal()" [backgroundColor]="'var(--darkest-primary)'">
                            Annuler
                        </frg-button>
                        <frg-button [disabled]="isSubmitDisabled" [type]="'submit'" [ngClass]="{ 'no-action': !formGroup.valid }"
                            [backgroundColor]="'var(--primary)'">
                            Créer</frg-button>
                    </div>
                </div>
                <div class="error-container group-error" [ngClass]="{'no-height': !isError}">
                    {{errorMessage}}
                </div>
            </form>
        </div>
    </div>
</div>
<div class="modal-background"></div>
